import React from 'react';
import { Button, IconButton } from '@mui/material';
import { arrayBufferToBase64 } from './form/FormInputFileUpload';

interface FileUploadButtonProps {
  name: string;
  children?: React.ReactNode | React.ReactNode[];
  disabled?: boolean | null;
  accept?: string | null;
  /** Allow selecting more than one file at once. Each selected file triggers its own onChange call. */
  multiple?: boolean;
  binary?: (name: string, type: string) => boolean;
  onChange: (name: string, type: string, content: any, size: number) => void;
  startIcon?: any;
  buttonProps?: {
    [key: string]: any;
  };
}

export default function FileUploadButton(props: FileUploadButtonProps) {
  const { name, accept, disabled, multiple, children, binary, onChange, startIcon, buttonProps, ...rest } = props;

  return (
    <label htmlFor={name}>
      {!disabled && (
        <input
          style={{ display: 'none' }}
          id={name}
          name={name}
          type="file"
          {...(accept ? { accept } : {})}
          {...(multiple ? { multiple: true } : {})}
          onChange={e => {
            const formfiles: File[] = Array.from((e.target as any).files || []);
            formfiles.forEach(formfile => {
              const asBinary = binary ? binary(formfile.name, formfile.type) : false;

              const reader = new FileReader();
              reader.onload = async eo => {
                onChange(
                  formfile.name,
                  formfile.type,
                  asBinary ? arrayBufferToBase64((eo.target as any).result) : (eo.target as any).result,
                  formfile.size
                );
              };
              if (asBinary) {
                reader.readAsArrayBuffer(formfile);
              } else {
                reader.readAsText(formfile);
              }
            });
            // Allow re-selecting the same file(s) again later.
            e.target.value = '';
          }}
        />
      )}
      {!children && startIcon && (
        <IconButton component="span" disabled={!!disabled} {...buttonProps}>
          {startIcon}
        </IconButton>
      )}
      {children && (
        <Button color="secondary" variant="contained" component="span" disabled={!!disabled} startIcon={startIcon} {...buttonProps}>
          {children}
        </Button>
      )}
    </label>
  );
}
